import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Referrer } from '../classes/referrer';
import config from '../config.json';

@Injectable({
    providedIn: 'root'
})
export class ReferrerService {
    API_REFERRER_URL = config.serverAddress + ':' + config.serverPort + '/referrer/';

    constructor(private http: HttpClient) { }

    getAll() {
        return this.http.get<Array<Referrer>>(this.API_REFERRER_URL + 'all');
    }

    getByID(id: string | null) {
        return this.http.get<Referrer>(this.API_REFERRER_URL + id);
    }

    create(referrer: Referrer) {
        return this.http.post<Referrer>(this.API_REFERRER_URL + 'create', referrer);
    }

    update(referrer: Referrer) {
        return this.http.put<Referrer>(this.API_REFERRER_URL + 'update', referrer);
    }

    delete(id: number | undefined) {
        return this.http.delete(this.API_REFERRER_URL + 'delete/' + id);
    }
}
